import { PlanSalud } from "../../maestro/entity/plan-salud.model";
import { TipoIdentificacion } from '../../maestro/entity/tipo-identificacion.model';
import { TipoPlanParticular } from '../../maestro/entity/tipo-plan-particular.model';
import { Convenio } from '../entity/convenio.model';
import { BebeCanguro } from '../entity/plan-manejo/valoraciones/bebe-canguro.model';

export class
PacienteCobertura {

  constructor(
    public idRemisionPK: string,
    public nombre: string,
    public apellido: string,
    public tipoIdentificacion: TipoIdentificacion,
    public numeroIdentificacion: string,
    public fechaNacimiento: string,
    public edad: string,
    public sexo: string,
    public estadoCivil: string,
    public tipoPlanParticular: TipoPlanParticular,
    public ocupacion: string,
    public email: string,
    public tipoAsegurador: string,
    public estadoSuspension: string,
    public coberturaDomiciliaria: boolean,
    public fechaLimiteCobertura: string,
    public tipoAfiliacion: PlanSalud,
    public convenios: Convenio[],
    public nivelIngreso: string,
    public ipsBasicaAsignada: string,
    public lugarAtencion: string,
    public unidadEdad: string,
    public bebeCanguro: BebeCanguro[],
    public codigoARL: string,
    public medidaDepeso: string,
    public peso: string,
    public codigoSiniestro: string,
    public planComplementario: string,
    public esEditable: boolean,
    public priorizacion: string,
    public fechaConsultaMedica: string,
    public fechaInicioSintomas: string,
    public fechaTomaMuestra: string,
    public tipoCasoCovid: string,
    public integracion: string,
    public observacion: string,
    public pacienteSinFechaNacimiento: string,
    public encounterId: string,
    public embarazada: string,
    public oxigenoDependiente: string,
    public medicoCreadorTipo: string,
    public medicoCreadorNumero: string,
    public codigoSexo: string,
    public descSexo: string,
    public codigoPlan: string,
    public descPlan: string,
    public descMunicipio: string,
    public codigoDaneMunicipio: string,
    public descDepartamento: string,
    public codigoDaneDpto: string,
    public pisoCovid: string,
    public subNivel: number,
    public vacunacion: string,
    public nombrePersonaAutoriza?: string,
    public tienePoliza?: boolean,
    public tienePac?: boolean,
    public tienePOS?: boolean,
    public tieneArl?: boolean
  ) {
  }
}
